<div class="image-wrapper">
    <img loading="lazy" src="assets/action-denied.png" class="lg">
    <h6>{{msg}}</h6>
    <a class="text-info" (click)="gotoPage()">Need help?</a>
</div>